import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskLectureGroupMemberVm } from '../my-osk-lecture-group-member-vm.model';
import { IMyOskLectureGroupMemberIm } from '../my-osk-lecture-group-member-im.model';
@Injectable({ providedIn: 'root' })
export class MyOskLectureGroupMemberService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskLectureGroupMember`;
  }
  post(myOskLectureGroupMemberIm: IMyOskLectureGroupMemberIm): Observable<IMyOskLectureGroupMemberVm> {
    const headers = this.createHeaders();
    return this.http.post<IMyOskLectureGroupMemberVm>(this.baseUrl, myOskLectureGroupMemberIm, { headers });
  }
  delete(lectureGroupGuid: string, studentGuid: string): Observable<boolean> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (lectureGroupGuid !== undefined && lectureGroupGuid !== null) {
      params = params.set('lectureGroupGuid', lectureGroupGuid.toString());
    }
    if (studentGuid !== undefined && studentGuid !== null) {
      params = params.set('studentGuid', studentGuid.toString());
    }
    return this.http.delete<boolean>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
